@if (variant === 'svg') {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden="true"
  >
    <g clip-path="url(#a)">
      <path fill="#fff" d="M7 8h11v8H7V8Z" />
      <path
        [attr.fill]="backgroundColor"
        d="M20.895 8.67a.841.841 0 0 1-.255-.6V5.7a2.342 2.342 0 0 0-2.34-2.34h-2.37a.842.842 0 0 1-.6-.255L13.665 1.44a2.363 2.363 0 0 0-3.33 0L8.67 3.105a.842.842 0 0 1-.6.255H5.7A2.343 2.343 0 0 0 3.36 5.7v2.37a.841.841 0 0 1-.255.6L1.44 10.335a2.363 2.363 0 0 0 0 3.33l1.665 1.665a.841.841 0 0 1 .255.6v2.37a2.343 2.343 0 0 0 2.34 2.34h2.37a.842.842 0 0 1 .6.255l1.665 1.665a2.353 2.353 0 0 0 3.33 0l1.665-1.665a.843.843 0 0 1 .6-.255h2.37a2.342 2.342 0 0 0 2.34-2.34v-2.37a.842.842 0 0 1 .255-.6l1.665-1.665a2.362 2.362 0 0 0 0-3.33L20.895 8.67Zm-5.37 1.86-3.99 4.005a.78.78 0 0 1-1.065 0l-1.995-2.01a.742.742 0 0 1 1.05-1.05l1.47 1.47 3.48-3.48a.752.752 0 0 1 1.275.533.744.744 0 0 1-.225.532Z"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath>
    </defs>
  </svg>
}

@if (variant === 'custom-font-icon') {
  <div class="btv-icon-btn-check"></div>
}
